// extracted by mini-css-extract-plugin
export var table = "_yi-0";